import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Profile } from '@turnifly/shared/types';

interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  isNewUser: boolean;
  isNotRegistered: boolean;
  user: Profile | null;
  setUser: (user: Profile | null) => void;
  setAuthenticated: (value: boolean) => void;
  setNewUser: (value: boolean) => void;
  setNotRegistered: (value: boolean) => void;
  setLoading: (value: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      isLoading: true, // initial load state
      isNewUser: false,
      isNotRegistered: false,
      user: null,
      setUser: (user) => set({ user }),
      setAuthenticated: (value) => set({ isAuthenticated: value }),
      setNewUser: (value) => set({ isNewUser: value }),
      setNotRegistered: (value) => set({ isNotRegistered: value }),
      setLoading: (value) => set({ isLoading: value }),
      logout: () => set({ isAuthenticated: false, user: null, isNewUser: false, isNotRegistered: false }),
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ 
        isAuthenticated: state.isAuthenticated, 
        isNewUser: state.isNewUser,
        user: state.user 
      }), // don't persist isLoading
    }
  )
);
